import styled from 'styled-components';
import { paddings } from '~/styled/GlobalStyles';

type Props = {
  $isSelected: boolean;
};

type DropdownProps = {
  $isExpanded?: boolean;
};

type IconProps = {
  $placement: 'left' | 'right';
};

export const Shield = styled.aside`
  width: 5px;
  display: flex;
  height: 100%;
  flex-direction: column;
  place-content: flex-start center;
  align-items: flex-start;
`;

export const ShieldCenter = styled.div`
  background-color: ${({ theme }) => theme.colors.orange500};
  width: 100%;
`;

export const ShieldEdge = styled.svg`
  height: 6px;
  width: 5px;
  & path {
    stroke-width: 0;
  }
`;

export const DropdownContent = styled.div<DropdownProps>`
  transition: max-height 200ms ease;
  overflow: hidden;
  max-height: ${({ $isExpanded }) => ($isExpanded ? '600px' : '0')};
`;

export const MenuLabel = styled.div`
  padding: ${() => paddings.defaultPadding};
  text-transform: uppercase;
  flex-grow: 1;
`;

export const IconWrapper = styled.div<IconProps>`
  padding-left: ${({ $placement }) => ($placement === 'left' ? '16px' : '0')};
  padding-right: ${({ $placement }) => ($placement === 'right' ? '16px' : '0')};
`;

export const MenuItem = styled.li<Props>`
  height: 50px;
  display: flex;
  width: 100%;
  cursor: pointer;
  font-weight: 700;
  align-items: center;
  color: ${({ $isSelected, theme }) =>
    $isSelected ? theme.colors.onSurface : theme.colors.onBackground};

  &:hover ${ShieldCenter}, &:hover ${ShieldEdge} {
    & path {
      fill: ${({ theme }) => theme.colors.orange500};
    }
  }
  &:hover {
    color: ${({ theme }) => theme.colors.onSurface};
  }
  ${ShieldCenter} {
    height: ${({ $isSelected }) => ($isSelected ? '8px' : '0')};
  }
  ${ShieldEdge} {
    & path {
      fill: ${({ theme, $isSelected }) => ($isSelected ? theme.colors.orange500 : 'transparent')};
    }
  }
`;
